export default __webpack_public_path__ + "static/media/Poppins-ExtraBold.41c2143a.ttf";